export const theme = {
    colors: {
      hover: "#474343",
      primary: "#dddddd",
      background: "#0f0e0e",
    },
    sizes: {
      borderRadius: "25px",
      circleRadius: "4px",
      font: {
        big: "1.5rem",
        medium: "1rem",
        small: "0.8rem",
      },
      containers: {
        full: "100%",
        big: "750px",
        medium: "130px",
        small: "70px",
        extrasmall: "33px",
        textSize: "20px",
      },
      space: {
        none: "0px",
        smallNoSides: "1rem 0",
        mediumNoSides: "3rem auto",
        bigNoSides: "4.4rem 0",
      },
      resolutions: {
        mobile: "400px",
        tablet: "810px",
      },
    },
  };